module.exports = __webpack_public_path__ + "6c4a0dbc/img/arrow-export-icon.a3345173.svg";